import { Box, Typography } from '@mui/material';
import useStore from '~/store';
import * as styles from './styles';

export const EquipmentValue = () => {
  const { equipmentvalue, insuredAmount } = useStore((store) => ({
    equipmentvalue: store.quote.equipmentValue,
    insuredAmount: store.insured_item.insured_amount
  }));

  const value = equipmentvalue || insuredAmount;
  const formattedValue =
    typeof value === 'number' && !isNaN(value)
      ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : '--';

  return (
    <Box>
      <Box sx={() => styles.containerMessage()}>
        <Box sx={styles.inputStyle}>
          <Typography fontWeight="bold" fontSize={20}>
            {formattedValue}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
